var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubCostlineArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C7.71525 21 5.04434 19.8938 3.07539 17.9246C1.10617 15.9555 0 13.2849 0 10.5C0 7.71513 1.10617 5.04434 3.07539 3.0754C5.04446 1.10617 7.71513 0 10.5 0C12.3431 0 14.1538 0.485094 15.75 1.40672C17.3462 2.32836 18.6717 3.6538 19.5933 5.25C20.5149 6.84624 21 8.65693 21 10.5C21 13.2847 19.8938 15.9557 17.9246 17.9246C15.9555 19.8938 13.2849 21 10.5 21ZM15.6616 9.57829L11.6826 5.59934C11.3667 5.2834 10.9063 5.16004 10.4747 5.27569C10.0432 5.39134 9.70614 5.72841 9.59053 6.15998C9.47488 6.59143 9.59824 7.05185 9.91418 7.36779L11.8263 9.26222H6.22027C5.77481 9.26222 5.36326 9.49983 5.14047 9.88562C4.91781 10.2713 4.91781 10.7465 5.14047 11.1323C5.36328 11.5181 5.77481 11.7557 6.22027 11.7557H11.7995L9.91832 13.639C9.60238 13.955 9.47902 14.4154 9.59467 14.8468C9.71032 15.2784 10.0474 15.6155 10.4788 15.7311C10.9104 15.8468 11.3708 15.7234 11.6866 15.4075L15.6656 11.4285C15.9104 11.1832 16.041 10.8464 16.0259 10.5001V10.4603C16.0267 10.1294 15.8956 9.81205 15.6616 9.57829Z",
    fill: "#123383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubCostlineArrow);
export default __webpack_public_path__ + "static/media/subCostline_arrow.33e4f6d58475af9b6fbe12771cd22656.svg";
export { ForwardRef as ReactComponent };